export default (val) => {
  if (!val) {
    return ''
  }

  val = val.toString()

  if (!val || val.length < 10) {
    return val
  }

  return `(${val.substr(0, 3)}) ${val.substr(3, 3)}-${val.substr(6)}`
}
